import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { timer } from 'rxjs';
import { map, tap, retryWhen, delayWhen } from 'rxjs/operators';
import { IResGetCryptoMoneyInfo } from './vouchers.interface';

@Injectable({
  providedIn: 'root',
})
export class VouchersService {
  constructor(protected http: HttpClient) {}

  getTransactionCryptoMoneyInfo(): Observable<IResGetCryptoMoneyInfo> {
    const url = '/api/v2/checkout/getTransactionCryptoMoneyInfo';
    let retryAttempt = 1;
    return this.http.post<IResGetCryptoMoneyInfo>(url, {}).pipe(
      map((response) => {
        if (response.code === '00000') {
          return response;
        } else {
          throw new HttpErrorResponse({
            error: response,
            url,
          });
        }
      }),
      retryWhen((errors) =>
        errors.pipe(
          tap((val) => {
            retryAttempt++;
            if (retryAttempt > 7) {
              throw new HttpErrorResponse({
                error: val,
                url,
              });
            }
          }),
          delayWhen((val) => timer(500))
        )
      )
    );
  }
}
